/**
 * X syndication JSON sometimes omits entity arrays or sets them to non-arrays.
 * react-tweet's enrichTweet → getEntities() does `for..of` on each list and throws
 * "entities is not iterable" when a value is missing or not iterable.
 */
export function normalizeSyndicationTweetEntities(
  tweet: Record<string, unknown>,
): Record<string, unknown> {
  const out: Record<string, unknown> = { ...tweet }
  const raw = tweet.entities
  const defaultEntities = {
    hashtags: [],
    urls: [],
    user_mentions: [],
    symbols: [],
  }
  if (raw && typeof raw === 'object' && !Array.isArray(raw)) {
    const r = raw as Record<string, unknown>
    const entities: Record<string, unknown> = {
      ...r,
      hashtags: Array.isArray(r.hashtags) ? r.hashtags : [],
      urls: Array.isArray(r.urls) ? r.urls : [],
      user_mentions: Array.isArray(r.user_mentions) ? r.user_mentions : [],
      symbols: Array.isArray(r.symbols) ? r.symbols : [],
    }
    if (r.media !== undefined) {
      entities.media = Array.isArray(r.media) ? r.media : []
    }
    out.entities = entities
  } else {
    out.entities = defaultEntities
  }

  const qt = tweet.quoted_tweet
  if (qt && typeof qt === 'object' && !Array.isArray(qt)) {
    out.quoted_tweet = normalizeSyndicationTweetEntities(qt as Record<string, unknown>)
  }
  const parent = tweet.parent
  if (parent && typeof parent === 'object' && !Array.isArray(parent)) {
    out.parent = normalizeSyndicationTweetEntities(parent as Record<string, unknown>)
  }
  return out
}
